module.exports = __webpack_public_path__ + "img/mail-black.6257d8b5.png";